import xtend from "xtend";
import mxtend from "xtend/mutable";
import xhr from "xhr";
import urlJoin from "url-join";
import Api from "@invintusmedia/api-adapter";

import store from "../redux/store";

export default function ApiAdapter(opts) {
  // billing:
  var BILLING_URL = 'https://playerstats-v2.invintus.com';
  var ANALYTICS_URL = BILLING_URL;
  //var ANALYTICS_URL = 'https://playerstats-v2.invintus.com';

  // for the playerstats server:
  var ANALYTICS_NAME = "KvqPoHG2MH4YsbKpP468XGHHs";
  var ANALYTICS_KEY = "7WmdkuQ8o4kL6X6rzCuqahmfT";

  var analyticsDefault = {
    headers: {
      authorization: ANALYTICS_NAME,
      "wsc-api-key": ANALYTICS_KEY,
    },
    body: { clientID: opts.clientID },
  };

  let apiOptions = {
    Authorization: opts.vendorName,
    "wsc-api-key": opts.vendorKey,
    clientID: opts.clientID,
    crudUrl: opts.crudUrl,
    publicUrl: opts.publicUrl,
  };

  var api = Api(apiOptions);
  var domains = (window.api = {
    events: mxtend(api.events, {
      miscAssetToEvent: function (opts, cb) {
        return api.assets.miscAssetToEvent(opts, function (err, resp) {
          if (err) return cb(err);
          cb(null, xtend({ data: resp.data }, { opts: opts }));
        });
      },

      publish: function (data, cb) {
        return api([opts.crudUrl, "Publish", "publish"])(data, cb);
      },

      unpublish: function (data, cb) {
        return api([opts.crudUrl, "Publish", "unpublish"])(data, cb);
      },
    }),

    analytics: xtend(api.analytics, {
      get: api.analytics.get,

      // getMostWatched: api.analytics.getMostWatched,
      // getUpcomingEvents: function (opts, cb) {
      //     return api.events.get(opts, cb);
      // },

      // getPlayStats: function (data, cb) {
      //     var url = urlJoin(ANALYTICS_URL, 'stats', 'getPlayStats');
      //     xhr.post({
      //         url,
      //         headers: analyticsDefault.headers,
      //         body: xtend(analyticsDefault.body, data),
      //         json: true
      //     }, function (err, res, body) {
      //         if (err) return cb(err);
      //         cb(null, body);
      //     });
      // },

      getBillingUsageMTD: function (data, cb) {
        var url = urlJoin(BILLING_URL, "stats", "getBillingUsageMTD");

        xhr.post(
          {
            url: url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      getBillingUsageLM: function (data, cb) {
        var url = urlJoin(BILLING_URL, "stats", "getBillingUsageLM");

        xhr.post(
          {
            url: url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      // getPlayStatsSimple: function (data, cb) {
      //     var url = urlJoin(ANALYTICS_URL, 'stats',AF
      //         'getPlayStatsSimple');
      //     xhr.post({
      //         url,
      //         headers: analyticsDefault.headers,
      //         body: xtend(analyticsDefault.body, data),
      //         json: true
      //     }, function (err, res, body) {
      //         if (err) return cb(err);
      //         cb(null, body);
      //     });
      // },

      getAvgPlayLen: function (data, cb) {
        var url = urlJoin(ANALYTICS_URL, "stats", "getAvgPlayLen");
        xhr.post(
          {
            url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      getTopBrowsers: function (data, cb) {
        var url = urlJoin(ANALYTICS_URL, "stats", "getTopBrowsers");
        xhr.post(
          {
            url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      getTopOS: function (data, cb) {
        var url = urlJoin(ANALYTICS_URL, "stats", "getTopOS");
        xhr.post(
          {
            url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      getTopDevices: function (data, cb) {
        var url = urlJoin(ANALYTICS_URL, "stats", "getTopDevices");
        xhr.post(
          {
            url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      getTopReferrers: function (data, cb) {
        var url = urlJoin(ANALYTICS_URL, "stats", "getTopReferrers");
        xhr.post(
          {
            url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      getTopStates: function (data, cb) {
        var url = urlJoin(ANALYTICS_URL, "stats", "getTopStates");
        xhr.post(
          {
            url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },

      getTopCities: function (data, cb) {
        var url = urlJoin(ANALYTICS_URL, "stats", "getTopCities");
        xhr.post(
          {
            url,
            headers: analyticsDefault.headers,
            body: xtend(analyticsDefault.body, data),
            json: true,
          },
          function (err, res, body) {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },
    }),

    accounts: {
      ticket: function (data, cb) {
        api([opts.crudUrl, "Accounts", "ticket"])(data, cb);
      },
      requestNewResetToken: function (data, cb) {
        api([opts.crudUrl, "Accounts", "requestNewResetToken"])(data, cb);
      },
    },

    feeds: {
      getPersistent: api([opts.publicUrl, "Feeds", "get247Feeds"]),
    },

    channels: xtend(api.eventListing, api.embeddedListing),
    player: xtend(api.player, api.playerPreferences),
    assets: xtend(api.assets, {
      editLink: function (data, cb) {
        api([opts.crudUrl, "asset", "updateLinkedAsset"])(data, cb);
      },
    }),
    message: api.messages,
    keywords: xtend(api.keywords, {
      getKeywordsNonPage: (data, cb) => {
        const url = urlJoin(opts.publicUrl, "Console", "getKeywordsNonPage");

        xhr.post(
          {
            url,
            body: {
              ...data,
              clientID: apiOptions.clientID,
            },
            headers: {
              authorization: apiOptions.Authorization,
              "wsc-api-key": apiOptions["wsc-api-key"],
            },
            json: true,
          },
          (err, res, body) => {
            if (err) return cb(err);
            cb(null, body);
          }
        );
      },
      getKeywordsSlim: (cb) => {
        const url = urlJoin(opts.publicUrl, "Console", "getKeywordSlim");

        xhr.post(
          {
            url,
            body: { clientID: apiOptions.clientID },
            headers: {
              authorization: apiOptions.Authorization,
              "wsc-api-key": apiOptions["wsc-api-key"],
            },
            json: true,
          },
          (err, res, { data }) => {
            if (err) return cb(err);
            cb(null, data);
          }
        );
      },
      get: (data, cb) => {
        // this if check handles and sets the initial get requests body
        if (typeof data === "function") {
          cb = data;
          data = {
            resultPage: 1,
            resultMax: 5,
            listEvents: false,
          };
        }

        const url = urlJoin(opts.publicUrl, "Console", "getKeywords");

        xhr.post(
          {
            url,
            body: {
              ...data,
              clientID: apiOptions.clientID,
            },
            headers: {
              authorization: apiOptions.Authorization,
              "wsc-api-key": apiOptions["wsc-api-key"],
            },
            json: true,
          },
          (err, res, body) => {
            const formattedBody = {
              clientKeywords: body.data.clientKeywords,
              meta: body.meta,
              noParse: true,
            };

            if (err) return cb(err);
            cb(null, formattedBody);
          }
        );
      },
      getKeywordsByIds: (data, cb) => {
        const url = urlJoin(opts.publicUrl, "Console", "getKeywords");

        xhr.post(
          {
            url,
            body: {
              ...data,
              clientID: apiOptions.clientID,
            },
            headers: {
              authorization: apiOptions.Authorization,
              "wsc-api-key": apiOptions["wsc-api-key"],
            },
            json: true,
          },
          (err, res, { data }) => {
            if (err) return cb(err);
            cb(null, data);
          }
        );
      },
    }),
    technicians: api.technicians,
    locations: api.locations,
    encoders: api.encoders,
    categories: api.categories,
    billing: api.billing,
    metamarkers: api.metamarkers,
    users: api.users,
    keys: api.keys,
    publish: api.publish,
    thumbs: api.thumbnails,
    edit: api.edit,
    vast: api.vast,
    facebookLive: api.facebook,
    p2p: api.p2p,

    streamTargets: xtend(
      api.alternateEventStreamDestination,
      api.streamTargetProviders
    ),

    // alternateEventStreamDestination: api.alternateEventStreamDestination,
    // streamTargetProviders: api.streamTargetProviders,

    vocabulary: {
      getTranscriptVocabularyByID: api([
        opts.publicUrl,
        "Transcript",
        "getTranscriptVocabularyByID",
      ]),

      getTranscriptVocabularies: api([
        opts.publicUrl,
        "Transcript",
        "getTranscriptVocabularies",
      ]),

      create: api([opts.crudUrl, "Transcripts", "createVocabulary"]),
      delete: api([opts.crudUrl, "Transcripts", "deleteVocabulary"]),
      update: api([opts.crudUrl, "Transcripts", "updateVocabulary"]),
    },

    transcript: {
      getTranscriptInfo: api([
        opts.publicUrl,
        "Transcript",
        "getTranscriptInfo",
      ]),

      setUseAsCaptions: api([opts.crudUrl, "Transcripts", "setUseAsCaptions"]),

      setUseText: api([opts.crudUrl, "Transcripts", "setUseText"]),
      resubmit: api([opts.crudUrl, "Transcripts", "resubmit"]),
      create: api([opts.crudUrl, "Transcripts", "create"]),
      delete: api([opts.crudUrl, "Transcripts", "delete"]),
    },

    restrictedDomains: api.restrictedDomains,

    audioDescription: {
      getProject: api([opts.publicUrl, "AdStudio", "getAdProject"]),
    },

    ott: {
      getChannels: api([opts.publicUrl, "Console", "getOttChannels"]),
      getChannelByID: api([opts.publicUrl, "Console", "getOttChannelByID"]),
      add: api([opts.crudUrl, "ott", "add"]),
      edit: api([opts.crudUrl, "ott", "update"]),
      delete: api([opts.crudUrl, "ott", "delete"]),
    },

    ottJob: {
      add: api([opts.crudUrl, "ottJob", "add"]),
    },

    chat: {
      // getModerators: api([opts.crudUrl, 'Chatauth', 'getModerators']),
      // createModerator: api([opts.crudUrl, 'Chatauth', 'createModerator']),
      // deleteModerator: api([opts.crudUrl, 'Chatauth', 'deleteModerator']),
      // resetPassword: api([opts.crudUrl, 'Chatauth', 'resetpw'])
      getModerators: api([opts.chatUrl, "Chatauth", "getModerators"]),
      createModerator: api([opts.chatUrl, "Chatauth", "createModerator"]),
      deleteModerator: api([opts.chatUrl, "Chatauth", "deleteModerator"]),
      resetPassword: api([opts.chatUrl, "Chatauth", "resetpw"]),
      updateChatSettings: api([opts.chatUrl, "Chatauth", "updateChatSettings"]),
    },

    upload: {
      newUpload: api([opts.crudUrl, "upload", "newUpload"]),
    },
  });
  // add passthrough for api requests so they are available to redux
  Object.keys(domains).forEach((domain) => {
    Object.keys(domains[domain]).forEach((requestType) => {
      const next = domains[domain][requestType];
      domains[domain][requestType] = (...args) => {
        const payload = args[0];
        store.dispatch({
          type: `API_REQUEST_${domain}_${requestType}_FETCH_REQUEST`,
          payload,
        });
        // @TODO: to fully use redux we should ignore the callbacks and then use the redux store to update the ui with the changes
        // sometimes the callback is the first argument if there are no parameters
        let callback;
        let callbackArgIndex;
        if (typeof args[1] === "function") {
          callback = args[1];
          callbackArgIndex = 1;
        } else if (typeof args[0] === "function") {
          callback = args[0];
          callbackArgIndex = 0;
        }
        const onResponse = (...res) => {
          store.dispatch({
            type: `API_REQUEST_${domain}_${requestType}_FETCH_RESPONSE`,
            payload: { ...res },
          });
          try {
            if (callback && typeof callback === "function") {
              callback(...res);
            }
          } catch (err) {
            console.log(
              "could not use callback with response:",
              err,
              res,
              domain,
              requestType,
              payload,
              callback
            );
          }
        };
        if (callback) {
          args[callbackArgIndex] = onResponse;
        }
        return next.apply(this, args);
      };
    });
  });
  return domains;
}
